module.exports = __webpack_public_path__ + "static/media/starship.69339ce4.svg";